import type { StateCreator } from 'zustand';
import type { Screen } from '@/types';

export interface NavigationSlice {
  screen: Screen;
  previousScreen: Screen | null;
  setScreen: (screen: Screen) => void;
  rightPanelTab: 'presets' | 'creations';
  setRightPanelTab: (tab: 'presets' | 'creations') => void;
}

export const navigationInitialState = {
  screen: 'library' as Screen,
  previousScreen: null as Screen | null,
  rightPanelTab: 'presets' as const,
};

export const createNavigationSlice: StateCreator<
  NavigationSlice,
  [],
  [],
  NavigationSlice
> = (set, get) => ({
  ...navigationInitialState,

  setScreen: (screen) => {
    const currentScreen = get().screen;
    if (currentScreen !== screen) {
      set({ screen, previousScreen: currentScreen });
    }
  },

  setRightPanelTab: (rightPanelTab) => set({ rightPanelTab }),
});
